export default __webpack_public_path__ + "static/media/hourglass.813fa669.svg";